exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clanblack{font-family:ClanFFBlack!important;font-weight:400}.clanpro{font-family:ClanPro!important;font-weight:400}.clanprobold{font-family:ClanProBold!important;font-weight:400}.clanprobook{font-family:ClanProBook!important;font-weight:400}.backlink{float:left;margin-right:10px}.backlink .btn{height:23px;width:23px;line-height:23px;padding:0;color:#999}.backlink+h1{margin-left:33px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-471b24a1","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"silenceDeprecations":["legacy-js-api","import","global-builtin","color-functions","slash-div"],"quietDeps":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Global/BackLink.vue
// module id = 1281
// module chunks = 0